(() => {
  'use strict';
  const payload = document.getElementById('pg-landing-content');
  if (!payload) return;
  const data = JSON.parse(payload.textContent);
  const content = data.products.find(item => item.handle === data.handle);
  const root = document.querySelector('#pg-six-live, #pa-root');
  const purchase = root?.querySelector('#six-purchase, #pa-purchase');
  const story = root?.querySelector('#six-story, #pa-story');
  if (!content || !purchase || !story || root.dataset.landingExperience) return;
  root.dataset.landingExperience = '20261103';
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const link = (url, text) => `<a href="${esc(url)}">${esc(text)}</a>`;
  purchase.querySelector('h1').textContent = content.title;
  const intro = purchase.querySelector('.pg-six-intro, .pa-intro');
  if (intro) intro.textContent = content.value;
  const price = purchase.querySelector('#six-unit, #pa-unit');
  const overview = document.createElement('div');
  overview.className = 'pg-landing-overview';
  overview.innerHTML = `<p class="pg-landing-included">${esc(content.unit_note)}</p>`;
  price?.after(overview);
  // The old generic sentence repeats the new product-specific included summary.
  if (overview.nextElementSibling?.matches('p') && /Review the available design/.test(overview.nextElementSibling.textContent)) overview.nextElementSibling.remove();
  root.querySelectorAll('.pg-new-decor-stars, .pa-stars').forEach(node => node.remove());
  const actions = purchase.querySelector('.actions, .pa-actions');
  purchase.querySelectorAll(':scope > p').forEach(node => {
    if (/^Free standard shipping/.test(node.textContent.trim())) node.remove();
  });
  const delivery = document.createElement('div');
  delivery.className = 'pg-landing-delivery';
  delivery.innerHTML = `<p><strong>Free standard shipping</strong> to eligible destinations. No minimum order.</p><details><summary>Delivery &amp; order help</summary><p>Estimated U.S. delivery: 7–15 business days from ordering, including handling. Dates are estimates; Christmas arrival is not guaranteed.</p><p>${link(data.shipping, 'Delivery destinations & timing')} · ${link(data.refund, 'Returns & order issues')} · ${link(data.contact, 'Ask a question')}</p></details>`;
  actions?.after(delivery);
  story.innerHTML = `<section class="pg-landing-chapter"><h2>A closer look</h2><p>${esc(content.value)}</p>${data.image ? `<img src="${esc(data.image)}" width="1000" height="1000" loading="lazy" alt="${esc(content.title)} — product detail">` : ''}</section><section class="pg-landing-chapter"><h2>Know what you’re choosing</h2><ul>${content.facts.map(fact => `<li>${esc(fact)}</li>`).join('')}</ul><dl>${content.specs.map(([key, value]) => `<dt>${esc(key)}</dt><dd>${esc(value)}</dd>`).join('')}</dl></section><section class="pg-landing-chapter"><h2>Before you order</h2>${content.faq.map(item => `<details><summary>${esc(item.q)}</summary><p>${esc(item.a)}</p></details>`).join('')}<p>${link(data.contact, 'Need help choosing? Contact PactGem')}</p></section>`;
  root.querySelectorAll('#six-faq, .confidence, .pa-confidence, .trust-labels, .pa-trust, .services, .pa-services').forEach(node => node.classList.add('pg-landing-redundant'));
  purchase.querySelectorAll('.reassurance, .policies, .policy-details, .pa-policies').forEach(node => node.classList.add('pg-landing-redundant'));
  const hero = root.querySelector('#six-hero, #pa-hero');
  if (hero) {
    if (!hero.getAttribute('width')) hero.setAttribute('width', '1000');
    if (!hero.getAttribute('height')) hero.setAttribute('height', '1000');
    hero.setAttribute('fetchpriority', 'high');
  }
  // Use the existing controller's selection and submit button; no parallel purchase state.
  const dock = root.querySelector('.dock, .pa-dock');
  const mainAdd = purchase.querySelector('[data-purchase], [data-buy="cart"]');
  if (dock && mainAdd && !dock.querySelector('[data-purchase], [data-buy]')) {
    const add = document.createElement('button');
    add.type = 'button';
    add.className = 'pa-primary pg-landing-dock-add';
    add.textContent = 'ADD TO CART';
    add.addEventListener('click', () => { if (!mainAdd.disabled) mainAdd.click(); });
    dock.append(add);
    const sync = () => { add.disabled = mainAdd.disabled; add.textContent = mainAdd.disabled ? mainAdd.textContent : 'ADD TO CART'; };
    new MutationObserver(sync).observe(mainAdd, {attributes: true, attributeFilter: ['disabled'], childList: true});
    sync();
  }
  if (dock && mainAdd) {
    let mainVisible = true;
    const syncDock = () => {
      const editing = /INPUT|SELECT|TEXTAREA/.test(document.activeElement?.tagName || '');
      const cartOpen = !!document.querySelector('#pg-shopping-bag:not([hidden]), dialog[open]');
      dock.hidden = mainVisible || mainAdd.getBoundingClientRect().bottom > 0 || editing || cartOpen;
    };
    new IntersectionObserver(entries => { mainVisible = entries[0].isIntersecting; syncDock(); }).observe(mainAdd);
    window.addEventListener('scroll', syncDock, {passive: true});
    root.addEventListener('focusin', syncDock);
    root.addEventListener('focusout', () => setTimeout(syncDock, 0));
    new MutationObserver(syncDock).observe(document.body, {attributes: true, attributeFilter: ['style'], childList: true});
    syncDock();
  }
})();
